import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import { LOGIN_FORM_FIELD_HEIGHT } from '../../Login.constants'

import UserIcon from '../../../../../icons/user.svg'

function LoginAsEmployeeButton({ isLoading, ...restProps }) {
  const { t } = useTranslation()

  function handleClickLoginAsEmployee() {
    window.location.assign('/api/sso/login/')
  }

  return (
    <Button.Outlined
      {...restProps}
      beforeIconProps={{ Icon: UserIcon }}
      height={LOGIN_FORM_FIELD_HEIGHT}
      isLoading={isLoading}
      text={t('Auth.LoginAsEmployeeKey')}
      onClick={handleClickLoginAsEmployee}
    />
  )
}

export default LoginAsEmployeeButton
